import React, { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";
import './styles.css';
import { wordVariants, wrapperVariants } from "./variants";

const ProjMinorQuoteTile = ({data, minorQuote, aspectRatio, size, extraBelow=false, setMargin = "0vh 0 50vh 0"}) => {
    const [useSrc, setUseSrc] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);

    const { ref:upperRef, inView:upperInView, entry: upperEntry } = useInView({
        /* Optional options */
        triggerOnce: true,
        threshold: 0,
    });

    const { ref:lowerRef, inView:lowerInView, entry: loewrEntry } = useInView({
        /* Optional options */
        triggerOnce: true,
        threshold: 0,
    });


    useEffect(() => {
        if(size){
            let tmp = data.backgroundImage;
            tmp = tmp.replace("mobile", size);
            setUseSrc(tmp);
        }
    }, [size]);



    const imgVariants = {
        initial: {
            opacity: 0
        }, animate: {
            opacity: 1,
            transition: {
                duration: 1,
                delay: 0
            }
        }, exit: {
            opacity: 0
        }
    }

    return(
        <>
            {
                useSrc &&
                <div className="minor-quote-ele__wrapper"
                    style={{
                        margin: setMargin,
                        marginBottom: extraBelow ? "10vh" : "0vh"
                    }}
                >
                    { minorQuote &&
                        <div className="mquote__wrapper">
                            <motion.span 
                                className="min-q__wrapper"
                                ref={upperRef}
                                initial="initial"    
                                animate={upperInView ? "animate" : "initial"}
                                exit="exit"    
                                variants={wrapperVariants}
                            >
                                {minorQuote[0].split(" ").map((word, idx) => (
                                    <div><motion.span variants={wordVariants}>{word}&nbsp;</motion.span></div>
                                ))} 
                            </motion.span>
                            <motion.span 
                                className="min-q__wrapper hollow-text" ref={lowerRef}
                                initial="initial"    
                                animate={lowerInView ? "animate" : "initial"} 
                                exit="exit"    
                                variants={wrapperVariants}
                            >
                                    {minorQuote[1].split(" ").map((word, idx) => (
                                        <div><motion.span variants={wordVariants}>{word}&nbsp;</motion.span></div>
                                    ))}
                            </motion.span>
                        </div>
                    }
                    <div className="mquote-img__wrapper">
                        <div style={{
                             position: "relative",
                             left: "35%",
                             width: "65%",
                             overflow: "hidden",
                             aspectRatio: aspectRatio
                        }}>
                        <img 
                            src={data.placeholder} 
                            style={{
                                filter: "blur(5px)"
                            }}    
                        />
                        <motion.img 
                            initial="initial"
                            animate={isLoaded ? "animate" : "initial"}
                            exit="exit"
                            variants={imgVariants}
                            src={useSrc} 
                            onLoad={(e) => {
                                setIsLoaded(true);
                            } }
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                            }}
                        />
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default ProjMinorQuoteTile;